import { Child } from 'pym.js';

// Load base styles if needed
// import './styles/index.scss';

import './styles/graphic.scss';

import Zion from './utils/Zion';

const pkg = require('../package.json');

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child();

window.onload = () => {
  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};
